import { useHistory } from 'react-router-dom';
import { useCompany } from './contexts/CompanyContext';
import { useConfig } from './contexts/ConfigContext';
import { useUser } from './contexts/UserContext';
import React, { useEffect } from 'react';
import useAuth from './hooks/useAuth';
import { Spin } from 'antd';
import { app, contentPath, modules } from './config/const';

const navOptions = [
  modules.RegisterSale,
  modules.PendingSalesList,
  modules.BillList,
  modules.CreditNoteList,
  modules.DebitNoteList,
  modules.SalesReports,
  modules.StorageItemList,
  modules.ContactList,
  modules.POSList,
  modules.CashRegisterList,
  modules.CashSessionList,
];

function App(){
  const params = new URLSearchParams(window.location.search)
  const session = params.get('session') || ""
  const companyUid = params.get('company') || ""
  const {updateConfig} = useConfig()
  const {company,updateCompany} = useCompany()
  const {updateUser} = useUser()
  const history = useHistory()

  const fingerprint = "DEFUALT_FP"
  const {tokenData} = useAuth.useToken('authCsrfToken',session,null)
  const {data:baseData} = useAuth.useLoadBase(tokenData,{session,fingerprint,company:companyUid,module:"INICIO"})
  const {data:indexData} = useAuth.useIndex(tokenData,{
    session,
    company: companyUid,
    module: "INICIO"
  })

  useEffect(()=>{
    if(baseData && indexData?.user){
      updateConfig({
        showProgress: false,
        key:baseData.key || tokenData?.key,
        session,
        token: tokenData?.token?.uid
      })
      
      //permisos insuficientes
      if(baseData.status === 401 && baseData.redirect){
        window.location.href = baseData.redirect
        return
      }

      const defaultCompany = indexData.companies?.find((comp: any) => 
        indexData.permissions?.some((el: any) => el.key.toUpperCase().startsWith(app.Sales) && el.company_id === comp.id) &&
        indexData.modules?.some((mod: any) => mod.app.toUpperCase() === app.Sales && mod.company_id === comp.id)
      ) ?? indexData.companies?.find((comp: any) => 
        indexData.permissions?.some((el: any) => el.key.toUpperCase().startsWith(app.Sales) && el.company_id === comp.id)
      ) ?? indexData.companies?.find((comp: any) => 
        indexData.modules?.some((mod: any) => mod.app.toUpperCase() === app.Sales && mod.company_id === comp.id)
      ) ?? indexData.companies?.[0];

      const currentCompany = companyUid ? (indexData.companies?.find((comp: any) => comp.uid === companyUid) ?? defaultCompany) : defaultCompany;

      if(currentCompany){
        updateCompany({current:{...currentCompany, uid: currentCompany.uid || companyUid}})
      }

      const views: string[] = (indexData.permissions || [])
        .filter((el: any) => el.type === 'VIEW' && (!currentCompany || el.company_id === currentCompany.id))
        .map((el: any) => el.key);

      updateUser({
        ...indexData.user,
        permissions:{
          views,
          actions: (indexData.permissions || [])
            .filter((el: any) => el.type === 'ACTION' && (!currentCompany || el.company_id === currentCompany.id))
            .map((el: any) => el.key)
        },
        roles: indexData.permissions
      })

      const isDefaultAllowed = views.some(v => v.toLowerCase().includes(modules.RegisterSale.toLowerCase()));
      if (isDefaultAllowed) {
        history.push(contentPath[modules.RegisterSale]);
      } else {
        const firstAvailable = navOptions.find(key => views.some(v => v.toLowerCase().includes(key.toLowerCase())));
        if (firstAvailable) {
          history.push(contentPath[firstAvailable]);
        } else {
          history.push(contentPath[modules.RegisterSale]);
        }
      }
    }
  },[tokenData,baseData,indexData,companyUid,history,session])

  return(
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <Spin size="large" tip="Cargando..."  fullscreen/>
    </div>
  )
}

export default App;

